import {
    ANAO,
    AORIGEM_OS_MANUT_MANUAL,
    AOS_MANUT_VEICULO_ABERTA,
    AOS_MANUT_VEICULO_CORRETIVA,
    AOS_MANUT_VEICULO_PREVENTIVA,
    ASIM
} from 'consts';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    MULTIPART_CONFIG,
    validateSchemaFields
} from 'lib/formUtils';
import {
    appendFieldsToFormData,
    formatTime,
    getCodUsuarioRegistrou,
    getDateInputValue,
    getInputValue,
    getOnlyDigits
} from 'lib/functions';
import {
    getOrigemOsManut,
    getSituacaoOsManut,
    getSituacaoOsManutColor,
    validateComboFields
} from 'lib/configUtils';
import {
    Box,
    CardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import React, { Component } from 'react';
import ComboPadrao from 'views/Components/ComboPadrao';
import FormActions from 'views/Components/FormActions';
import FormTextArea from 'views/Components/FormTextArea';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class OsManutVeiculoForm extends Component {
    state = {
        osmanutveiculo: {
            codosmanutveiculo: '',
            tipoos: AOS_MANUT_VEICULO_CORRETIVA,
            situacao: AOS_MANUT_VEICULO_ABERTA,
            origem: AORIGEM_OS_MANUT_MANUAL,
            dataemissao: '',
            hora: '',
            socorro: '',
            codveiculo: '',
            hodometro: '',
            codfuncionariosolicitou: '',
            reclamacao: ''
        },
        isLoading: true,
        openAlert: false,
        messageAlert: '',
        errors: {},
        veiculos: [],
        motoristas: [],
        isNewRecord: false,
        isView: false,
        schema: {
            dataemissao: {
                presence: { allowEmpty: false, message: 'Data obrigatória' },
                format: {
                    pattern: /^\d{4}-\d{2}-\d{2}$/,
                    message: 'Data inválida'
                }
            },
            codveiculo: {
                presence: { allowEmpty: false, message: 'Veículo obrigatório' },
                type: 'integer'
            },
            hodometro: {
                presence: { allowEmpty: false, message: 'Hodômetro inválido' },
                type: 'integer'
            },
            codfuncionariosolicitou: {
                presence: { allowEmpty: false, message: 'Motorista obrigatório' },
                type: 'integer'
            },
            reclamacao: {
                presence: { allowEmpty: false, message: 'Reclamação obrigatória' },
                length: { maximum: 5000 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                await this.handleNewRecord();

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadOsManutVeiculo(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar OS de manutenção de veículo:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar OS de manutenção de veículo!'
                )
            );

            this.setState({ isLoading: false });
        }
    };

    /* Retorna a OS de manutenção de veículo padrão */
    getOsManutVeiculoDefault = () => {
        const hoje = new Date().toISOString().substring(0, 10);
        const agora = new Date().toTimeString().substring(0, 5);

        return {
            tipoos: AOS_MANUT_VEICULO_CORRETIVA,
            situacao: AOS_MANUT_VEICULO_ABERTA,
            origem: AORIGEM_OS_MANUT_MANUAL,
            dataemissao: hoje,
            hora: agora,
            socorro: ANAO,
            codveiculo: '',
            hodometro: 0,
            codfuncionariosolicitou: '',
            reclamacao: ''
        };
    };

    /* Carrega os veículos */
    loadVeiculos = async () => {
        const params = '?page=1&limit=500&veiculoproprio=S';
        const response = await api.get(`/veiculo/active/true${params}`);

        return getResponseData(response).map(item => ({
            ...item,
            placanroveiculo: item.placa && item.nroveiculo
                ? `${item.placa} [${item.nroveiculo}]`
                : (item.nroveiculo || '')
        }));
    };

    /* Carrega os motoristas */
    loadMotoristas = async () => {
        const params = '?page=1&limit=500&funcionario=S';
        const response = await api.get(`/fornecedor/active/true${params}`);

        return getResponseData(response);
    };

    /* Carrega os combos */
    loadCombos = async () => {
        const [veiculos, motoristas] = await Promise.all([
            this.loadVeiculos(),
            this.loadMotoristas()
        ]);

        return {
            veiculos,
            motoristas
        };
    };

    /* Carrega a OS de manutenção de veículo */
    loadOsManutVeiculo = async (id, isView) => {
        const response = await api.get(`/osmanutveiculo/${id}`);
        const dados = getRecordFromResponse(response) || {};
        const { veiculos, motoristas } = await this.loadCombos();

        this.setState({
            osmanutveiculo: {
                ...dados,
                socorro: dados.socorro || ANAO,
                hora: dados.hora || ''
            },
            isNewRecord: false,
            isLoading: false,
            isView,
            veiculos,
            motoristas
        });
    };

    /* Inicia um novo registro */
    handleNewRecord = async () => {
        const { veiculos, motoristas } = await this.loadCombos();

        this.setState({
            isNewRecord: true,
            isLoading: false,
            osmanutveiculo: this.getOsManutVeiculoDefault(),
            veiculos,
            motoristas
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, value, type, checked } = event.target;

        let adjustedValue;

        if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (type === 'radio') {
            adjustedValue = Number(value);
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            osmanutveiculo: {
                ...prevState.osmanutveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de OS de manutenção de veículo */
    getPayloadOsManutVeiculo = () => {
        const { osmanutveiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (!codusuarioregistrou) {
            throw new Error('Código do usuário não encontrado!');
        }

        const fields = {
            codusuarioregistrou,
            dataemissao: osmanutveiculo.dataemissao || '',
            hora: osmanutveiculo.hora || '',
            codveiculo: osmanutveiculo.codveiculo || '',
            hodometro: osmanutveiculo.hodometro || '',
            tipoos: osmanutveiculo.tipoos || '',
            situacao: osmanutveiculo.situacao || null,
            dataregistro: osmanutveiculo.dataregistro || '',
            horaregistro: osmanutveiculo.horaregistro || '',
            reclamacao: osmanutveiculo.reclamacao || '',
            codfuncionariosolicitou: osmanutveiculo.codfuncionariosolicitou || '',
            textoencerramento: osmanutveiculo.textoencerramento || '',
            codrequisicao: osmanutveiculo.codrequisicao || '',
            codusuarioencerrou: osmanutveiculo.codusuarioencerrou || '',
            datahoraencerramento: osmanutveiculo.datahoraencerramento || '',
            origem: Number(osmanutveiculo.origem ?? AORIGEM_OS_MANUT_MANUAL),
            codusuariocancelou: osmanutveiculo.codusuariocancelou || '',
            datahoracancelamento: osmanutveiculo.datahoracancelamento || '',
            motivocancelamento: osmanutveiculo.motivocancelamento || '',
            datahorareabertura: osmanutveiculo.datahorareabertura || '',
            codusuarioreabriu: osmanutveiculo.codusuarioreabriu || '',
            socorro: osmanutveiculo.socorro || ANAO
        };

        return appendFieldsToFormData(fields);
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { osmanutveiculo, isNewRecord } = this.state;
        const { history, loadOsManutVeiculo } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(osmanutveiculo, [
            {
                field: 'codveiculo',
                message: 'Selecione um veículo válido'
            },
            {
                field: 'codfuncionariosolicitou',
                message: 'Selecione um motorista válido'
            }
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            const formData = this.getPayloadOsManutVeiculo();

            if (isNewRecord) {
                await api.post(
                    '/osmanutveiculo',
                    formData,
                    MULTIPART_CONFIG
                );
            } else {
                await api.put(
                    `/osmanutveiculo/${osmanutveiculo.codosmanutveiculo}`,
                    formData,
                    MULTIPART_CONFIG
                );
            }

            if (loadOsManutVeiculo) loadOsManutVeiculo();

            history.push('/frotas/osmanutveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            const backendMsg = getApiErrorMessage(error, '');

            // tenta extrair o último hodômetro do texto
            const matchUltimo = backendMsg.match(/último\s+registrado\s*\((\d+)\)/i);
            const ultimoHodometro = matchUltimo ? matchUltimo[1] : null;

            if (ultimoHodometro) {
                this.handleOpenAlert(
                    `ERRO! O hodômetro deve ser igual ou superior ao último hodômetro (${ultimoHodometro}) do veículo!`
                );
            } else {
                this.handleOpenAlert(
                    getApiErrorMessage(
                        error,
                        'Erro ao salvar!'
                    )
                );
            }
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/osmanutveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { osmanutveiculo, schema } = this.state;

        const errors = validateSchemaFields(
            osmanutveiculo,
            schema,
            [
                'dataemissao',
                'codveiculo',
                'hodometro',
                'codfuncionariosolicitou',
                'reclamacao'
            ]
        );

        if (osmanutveiculo.hodometro === 0 || osmanutveiculo.hodometro === '0') {
            errors.hodometro = 'Hodômetro inválido!';
        }

        return errors;
    };

    /* Aceita somente dígitos */
    handleNumericChange = (event) => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            osmanutveiculo: {
                ...prevState.osmanutveiculo,
                [name]: getOnlyDigits(value)
            }
        }));
    };

    render() {
        const {
            errors,
            isLoading,
            isNewRecord,
            isView,
            messageAlert,
            motoristas,
            openAlert,
            osmanutveiculo,
            veiculos
        } = this.state;

        const situacaoTexto = isNewRecord ? 'nova' : getSituacaoOsManut(osmanutveiculo?.situacao);
        const situacaoCor = isNewRecord ? '#3a913f' : getSituacaoOsManutColor(osmanutveiculo?.situacao);
        const origemTexto = getOrigemOsManut(osmanutveiculo.origem);

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            style={{ gap: 16 }}
                        >
                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                OS {osmanutveiculo.codosmanutveiculo}
                            </Typography>

                            <Typography
                                component="h1"
                                variant="h3"
                            >
                                {!isLoading && (
                                    <span
                                        style={{
                                            padding: '5px 12px',
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            backgroundColor: '#f2f2f2',
                                            border: '1px solid #d0d0d0',
                                            borderRadius: 12,
                                            color: situacaoCor,
                                            display: 'inline-flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Situação: {situacaoTexto}
                                    </span>
                                )}
                            </Typography>
                        </Box>

                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            {!isLoading && (
                                <span
                                    style={{
                                        padding: '5px 12px',
                                        fontSize: '1rem',
                                        fontWeight: 600,
                                        backgroundColor: '#f2f2f2',
                                        border: '1px solid #d0d0d0',
                                        borderRadius: 12,
                                        color: '#616161',
                                        display: 'inline-flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    Origem: {origemTexto}
                                </span>
                            )}
                        </Typography>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        alignItems="center"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <FormControl
                            component="fieldset"
                            disabled={isView}
                            style={{
                                flex: '1 1 260px',
                                minWidth: 240
                            }}
                        >
                            <FormLabel component="legend">
                                Tipo OS
                            </FormLabel>

                            <RadioGroup
                                row
                                name="tipoos"
                                value={osmanutveiculo.tipoos}
                                onChange={this.onChange}
                            >
                                <FormControlLabel
                                    value={AOS_MANUT_VEICULO_PREVENTIVA}
                                    label={<span>Preventiva</span>}
                                    control={
                                        <Radio
                                            size="small"
                                            color="primary"
                                            disabled
                                        />
                                    }
                                />

                                <FormControlLabel
                                    value={AOS_MANUT_VEICULO_CORRETIVA}
                                    label={<span>Corretiva</span>}
                                    control={
                                        <Radio
                                            size="small"
                                            color="primary"
                                        />
                                    }
                                />
                            </RadioGroup>
                        </FormControl>

                        <TextField
                            label="Data emissão"
                            name="dataemissao"
                            onChange={this.onChange}
                            type="date"
                            value={getDateInputValue(osmanutveiculo.dataemissao)}
                            variant="outlined"
                            disabled={isView || isNewRecord}
                            helperText={errors.dataemissao || ''}
                            error={!!errors.dataemissao}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                minWidth: 150,
                                flex: '0 1 150px'
                            }}
                        />

                        <TextField
                            label="Hora"
                            name="hora"
                            onChange={this.onChange}
                            type="time"
                            value={formatTime(osmanutveiculo.hora)}
                            variant="standard"
                            disabled={isView}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                minWidth: 90,
                                flex: '0 1 90px'
                            }}
                        />

                        <FormControlLabel
                            label="Socorro"
                            control={
                                <Checkbox
                                    checked={(osmanutveiculo.socorro === ASIM)}
                                    name="socorro"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box>
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            fullWidth
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={osmanutveiculo.codveiculo}
                                onChange={this.onChange}
                                fieldId={'codveiculo'}
                                listItems={veiculos}
                                fieldDescription={'placanroveiculo'}
                                helperText={errors.codveiculo || ''}
                                error={!!errors.codveiculo}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Hodômetro"
                            name="hodometro"
                            value={getInputValue(osmanutveiculo.hodometro)}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView || !isNewRecord}
                            helperText={errors.hodometro || ''}
                            error={!!errors.hodometro}
                            inputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                maxLength: 6
                            }}
                            style={{ backgroundColor: (isView || !isNewRecord) ? '#f2f2f2' : 'transparent' }}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box>
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            fullWidth
                        >
                            <ComboPadrao
                                name={'codfuncionariosolicitou'}
                                label={'Solicitado por (motorista):'}
                                value={osmanutveiculo.codfuncionariosolicitou}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={motoristas}
                                fieldDescription={'fantasia'}
                                helperText={errors.codfuncionariosolicitou || ''}
                                error={!!errors.codfuncionariosolicitou}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box>
                        <FormTextArea
                            label="Reclamação"
                            name="reclamacao"
                            value={osmanutveiculo.reclamacao}
                            onChange={this.onChange}
                            disabled={isView}
                            error={errors.reclamacao}
                            minHeight={160}
                            resize="none"
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent >

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default OsManutVeiculoForm;